import React from 'react';
import { Wrapper, Heading, Logo, CopyRight, BodyHeading, Disclaimer, Body, Title, Portfolios, List, Link, ListItem, About } from './mobile.styles';
import { useTranslation } from 'react-i18next';


export const MobileFooter = ({logo, altLogo, disclaimer}) => {
  const { t } = useTranslation();
  const scrollTop = () => window.scrollTo({top: 0, scrollBehavior: 'smooth'});

  return (
    <Wrapper>
      <Heading>
        <Logo><img src={logo} alt={altLogo} /></Logo>
        <CopyRight>{'©' + new Date().getFullYear() + ' ' + t('FooterData.copyRight')}</CopyRight>
        <Disclaimer>
          <a href={disclaimer.privacyPolicy.url}>{t('FooterData.disclaimer.privacyPolicy.title')}&nbsp;</a>
          <a href={disclaimer.legalTerms.url}>{t('FooterData.disclaimer.legalTerms.title')}</a>
        </Disclaimer>
      </Heading>
      <Body>
        <BodyHeading>
          <Title>{t('FooterData.sitemap.title')}</Title>
          <Title>{t('FooterData.sitemap.sitename')}</Title>
        </BodyHeading>
        <Portfolios>
          <Link to='/portfolios' onClick={scrollTop}>
            <Title>{t('FooterData.sitemap.portfolios.title')}</Title>
          </Link>
          <List onClick={scrollTop}>
            <ListItem>
              <Link to='/portfolios/materials'>{t('FooterData.sitemap.portfolios.list.0.title')}</Link>
            </ListItem>
            <ListItem>
              <Link to='/portfolios/electronics'>{t('FooterData.sitemap.portfolios.list.1.title')}</Link>
            </ListItem>
            <ListItem>
              <Link to='/portfolios/robotics'>{t('FooterData.sitemap.portfolios.list.2.title')}</Link>
            </ListItem>
            <ListItem>
              <Link to='/portfolios/mobility'>{t('FooterData.sitemap.portfolios.list.3.title')}</Link>
            </ListItem>
            <ListItem>
              <Link to='/portfolios/manufacturing'>{t('FooterData.sitemap.portfolios.list.4.title')}</Link>
            </ListItem>
          </List>
        </Portfolios>
        <About>
          <Link to='/about'>
            <Title>{t('FooterData.sitemap.aboutUs.title')}</Title>
          </Link>
          <List>
            <ListItem>
              <Link to='/about/global-facilities'>{t('FooterData.sitemap.aboutUs.list.0.title')}</Link>
            </ListItem>
            <ListItem>
              <Link to='/about/partnership'>{t('FooterData.sitemap.aboutUs.list.2.title')}</Link>
            </ListItem>
          </List>
        </About>
      </Body>
    </Wrapper>
  )
}